export const GoogleMapApiConfig = 'AIzaSyCfJi-L88bx0MhNqkkO8l16LdSMPd2flNw';